import { RootState } from '../../store';
import { RiskUiState } from '../../slices/risks_ui';

export * from './select_ui_by_risk';
export * from './select_outreach_board_ui';
export * from './select_assessments_graph_ui';

export const selectRisksUi = (state: RootState): RiskUiState => state.risksUi;
